import { useState, useEffect } from 'react';
import Select from 'react-select';

import { IProduct } from '@interfaces';
import styles from '@components/common/products/product.styles';
import ProductFDA from '@components/common/products/partial/product-fda';
import { WPImage } from '@v2/utils/image';

export default function CollaborationIngredients({ product }: { product?: IProduct }) {
    const products = (product.collaboration && product.collaboration.cerebellyProducts) ? product.collaboration.cerebellyProducts : {};
    const [options, setOptions] = useState([]) as any;
    const [item, setItem] = useState(products ? products[0] : []) as IProduct | any;

    useEffect(() => {
        if (products) {
            let data = {} as any;

            Object.keys(products).forEach(key => {
                data[key] = {
                    'label': products[key].title,
                    'value': products[key].id
                }
            });

            setOptions(Object.values(data));
        }
    }, [products]);

    return (
        <>
            {products ?
                <div className={styles.ingredients} style={{flexDirection: 'column', width: '100%'}}>
                    <div className="pdp-ingredients-wrapp animated"
                        {...{ animations: "animate__animated animate__fadeInUp-home animate__delay-03s" }}>
                        <h3>NUTRITION FACTS & INGREDIENTS</h3>
                        <div className="products-dropdown">
                            <Select
                                options={options}
                                value={options.find((e: any) => e.value === item.id)}
                                onChange={(e: any) => setItem(products.find((p: any) => p.id === e.value))}
                                className={`select-dropdown`}
                                classNamePrefix="select" />
                        </div>
                    </div>
                    {item && <ProductFDA product={item} />}
                    <div className="ingedients-list">
                        INGREDIENTS:<br/>
                        <>
                        {item && item.ingredients &&
                            Object.values(item.ingredients.map((data: any, key: any) => data.title)).join(', ')
                        }
                        </>
                    </div>
                    <div className="ingedients-list-images">
                        {item.ingredients &&
                            Object
                                .values(item.ingredients)
                                .filter((ingredient: any) => ingredient.isKey)
                                .map((ingredient: any, key: number) =>
                                    key < 3 &&
                                    <div key={key} className="ingredient">
                                        <WPImage src={ingredient.image} alt={ingredient.title} />
                                        <span className="ingredient-title">{ingredient.title}</span>
                                    </div>
                                )}
                    </div>
                </div>
                : <></>
            }
        </>
    );
}